import { cn } from "@/lib/utils";
import { Mix_Content_Category_Enum } from "graphql/generated";
import { ClassAttributes, HTMLAttributes } from "react";

import { ContentAuthorName } from "./ContentAuthorName";
import { ContentCategoryChip } from "./ContentCategoryChip";
import { ContentSourceImg } from "./ContentSourceImg";
import { ContentUpdateTime } from "./ContentUpdateTime";

type ContentSourceAuthorHeaderProps = {
    sourceImgSize: number;
    sourceImgUrl: Mix_ContentFragment["mix_source_info"]["imgurl"];
    authorname: Mix_ContentFragment["authorname"];
    updatetime: Mix_ContentFragment["updatetime"];
    offlinetime: Mix_ContentFragment["offlinetime"];
    category: Mix_ContentFragment["category"];
    isContentDetailModal?: boolean;
    priority?: boolean;
} & ClassAttributes<HTMLElement> &
    HTMLAttributes<HTMLElement>;

export const ContentSourceAuthorHeader = ({
    sourceImgSize,
    sourceImgUrl,
    authorname,
    updatetime,
    offlinetime,
    category,
    className,
    isContentDetailModal = false,
    priority,
    ...props
}: ContentSourceAuthorHeaderProps) => {
    return (
        <header className={cn("flex items-center gap-2", className)} {...props}>
            {sourceImgUrl && (
                <ContentSourceImg
                    width={sourceImgSize}
                    height={sourceImgSize}
                    imgurl={sourceImgUrl}
                    priority={priority}
                />
            )}
            <div
                className={cn(
                    "flex w-full items-center justify-between",
                    isContentDetailModal && "flex-col items-start"
                )}
            >
                <div className="flex gap-3">
                    <ContentAuthorName>{authorname}</ContentAuthorName>
                </div>
                <ContentUpdateTime
                    updatetime={updatetime}
                    offlinetime={offlinetime}
                    isOffline={category === Mix_Content_Category_Enum.Offline}
                />
            </div>
        </header>
    );
};
